import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import BarcodeInput from 'components/field/BarcodeInput';
import Button from 'components/field/Button';
import IntegerInput from 'components/field/IntegerInput';
import Form from 'components/form/Form';
import FormItem from 'components/form/FormItem';
import MinimizeButton from 'components/global/MinimizeButton';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import { updateDynamicListsInPage } from 'components/list/dynamicListSlice';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useModalRouter from 'hooks/useModalRouter';

import { ORDER_ACTIONS } from 'services/consts';

import AppLogger from 'utils/AppLogger';

import InternationalProforma from '../PrintOrders/InternationalProforma';
import PrintAWB from '../PrintOrders/PrintAWB';

const CreateShipmentAndPrint = NiceModal.create(({ modalName }) => {
	const [isLoading, setIsLoading] = useState(false);
	const modal = useModal();
	const { closeModal } = useModalRouter();
	const axiosPrivate = useAxiosPrivate();
	const [packageCount, setPackageCount] = useState(1);
	const dispatch = useDispatch();

	const { showSuccess, showError } = useAlert();

	const onSubmit = (orderID, packageCount) => {
		setIsLoading(true);
		axiosPrivate
			.post(ORDER_ACTIONS.CREATE_SHIPMENT_AND_PRINT, {
				orderID,
				packageCount
			})
			.then((res) => {
				if (res.data?.data?.shipments[0].error) {
					showError({ message: res.data?.data?.shipments[0].error });
					return;
				}

				if (res.status === 204) {
					showError({ message: 'error.O001' });
					return;
				} else if (res.status !== 200) {
					showError();
					return;
				}

				const { data } = res;

				showSuccess({
					header: 'asyncShipmentCreated',
					message: 'asyncShipmentCreatedMessage'
				});

				dispatch(updateDynamicListsInPage());

				NiceModal.show(PrintAWB, {
					ids: [parseInt(data.data.shipments[0].id)]
				}).then((resolved) => {
					const { internationalOrders = null } = resolved;
					if (internationalOrders?.length > 0) {
						NiceModal.show(InternationalProforma, {
							ids: internationalOrders
						});
					}
				});
				setPackageCount(1);
			})
			.catch((error) => {
				AppLogger.error(error);
				showError();
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const handleBarcode = (barcode) => {
		if (packageCount > 0) {
			onSubmit(barcode, packageCount);
		} else {
			showError({ message: 'packageCountMustBeGreaterThanZero' });
		}
	};

	const handleCloseModal = useCallback(() => {
		if (modalName) {
			closeModal();
		} else {
			modal.remove();
		}
	}, [modalName]);

	return (
		<Modal
			maxWidth="x-small"
			className="modal-auto-shipment-print"
			name={modalName}
			minimizeButton={(show, close) => (
				<MinimizeButton onShow={show} onClose={close} label="createShipmentAuto" />
			)}>
			<ModalTitle>
				<Typography variant="p1">createShipmentAuto</Typography>
			</ModalTitle>
			<ModalContent>
				<Form borderless>
					<FormItem label="packageCount" required isLoading={isLoading}>
						<IntegerInput value={packageCount} setValue={setPackageCount} />
					</FormItem>
					<FormItem label="orderID" isLoading={isLoading}>
						<BarcodeInput onChange={handleBarcode} />
					</FormItem>
				</Form>
			</ModalContent>

			<ModalActions>
				<Button label="cancel" variant="outline" onClick={() => handleCloseModal()} />
			</ModalActions>
		</Modal>
	);
});

export default CreateShipmentAndPrint;
